import { Component, DOCUMENT, Inject, inject, Renderer2, signal } from '@angular/core';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { Canonical } from '../../services/canonical';
import { Api } from '../../services/api';
import { catchError, of, timeout } from 'rxjs';
import { ArticlesItems } from '../../interface/articles';
import { TruncatePipe } from '../../pipes/truncate-pipe';
import { RouterLink } from '@angular/router';
import { Optimizations } from '../../interface/optimization';

@Component({
  selector: 'app-home',
  imports: [
    Navbar,
    Footer,
    RouterLink,
    TruncatePipe
  ],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  title = inject(Title);
  meta = inject(Meta);
  articles = signal<ArticlesItems[]>([]);
  private api = inject(Api);
  private canonical = inject(Canonical);

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  private setOrgSchema(obj?: string) : void {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = obj!;
    this.renderer.addClass(script, 'aioseo-schema');
    this.renderer.appendChild(this.document.head, script);
  }

  private initialize() : void {
    this.api.getOptimizeHome()
    .pipe(
      timeout(10000),
      catchError(() => of({
        canonical: null,
        title: null,
        meta: null,
        org: null
      }))
    ).subscribe(obj => {
      this.canonical.setCanonicalUrl(obj.canonical!);
      this.title.setTitle(obj.title!);
      this.meta.addTags(JSON.parse(obj.meta!));
      this.setOrgSchema(obj.org!);
    });
    
    this.api.getLatestArticles()
    .pipe(
      timeout(10000),
      catchError(() => of([]))
    ).subscribe(article => {
      this.articles.set(article);
    });
  }

  ngOnInit() : void {
    this.initialize();
  }
}
